define([
	'internal_util/Util',
	'view/UIView',
	'amdi18n-loader?!identity/nls/IdentityDeleteView_strings',
	'lib/jquery'
], function (
	Util,
	UIView,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * IdentityDeleteView class
	 */
	function IdentityDeleteView(deleteCallback) {
		var _view;

		_view = (function () {
			var $view = jQuery(
					"<div id='skIdS_identity-delete-container'>" +
						"<p>" + Strings.message_text + "</p>" +
						"<div id='skIdS_identity-delete-revoke-checkbox'>" +
							"<input type='checkbox' checked='checked'>" +
							"<label>&nbsp;" + Strings.revoke_cloud_identity + "</label>" +
						"</div>" +
						"<button id='skIdS_identity-delete-button' type='button' class='btn btn-default'>" + Strings.delete_revoke + "</button>" +
					"</div>");

			$view.find('#skIdS_identity-delete-revoke-checkbox').on('click', function (event) {
				var $checkBox = $view.find('#skIdS_identity-delete-revoke-checkbox').children('input');

				if (event.target !== $checkBox[0]) {
					$checkBox.prop('checked', !$checkBox.is(':checked'));
				}

				if ($checkBox.is(':checked')) {
					$view.find('#skIdS_identity-delete-button').text(Strings.delete_revoke);
				} else {
					$view.find('#skIdS_identity-delete-button').text(Strings['delete']);
				}
			});

			$view.find('#skIdS_identity-delete-button').on('click', function () {
				Util.callCallbacks(deleteCallback,
						$view.find('#skIdS_identity-delete-revoke-checkbox').children('input').is(':checked'));
			});

			return $view;
		})();

		UIView.call(this);


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (identityState) {
			if (identityState === 'revoked') {
				_view.find('#skIdS_identity-delete-button').text(Strings.delete);
				_view.find('#skIdS_identity-delete-revoke-checkbox').children('input').prop('checked', true);
				_view.find('#skIdS_identity-delete-revoke-checkbox').hide(true);
			} else {
				_view.find('#skIdS_identity-delete-button').text(Strings.delete_revoke);
				_view.find('#skIdS_identity-delete-revoke-checkbox').children('input').prop('checked', true);
			}
		};
	}

	IdentityDeleteView.prototype = Object.create(UIView.prototype);

	return IdentityDeleteView;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/IdentityDeleteView.js
// module id = 341
// module chunks = 1